import type {
  ApplicationParameter,
  ApplicationParameterUpdateRequest,
} from '../../../types/api.generated';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${sessionStorage.getItem('tokenUser')}`,
});

const getAdminParameterUrl = (path = '') => {
  const base = process.env.REACT_APP_BACKEND_URL || '';
  return `${base}/admin/parameters${path}`;
};

const getErrorMessage = async (response: Response) => {
  const body = await response.text();
  return `${response.status} ${response.statusText}${body ? ` ${body}` : ''}`;
};

export const getAdminParameters = async (): Promise<ApplicationParameter[]> => {
  const response = await fetch(getAdminParameterUrl(), {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch parameters: ${await getErrorMessage(response)}`);
  }

  return response.json();
};

export const updateAdminParameter = async (
  code: string,
  payload: ApplicationParameterUpdateRequest,
): Promise<ApplicationParameter> => {
  const response = await fetch(getAdminParameterUrl(`/${encodeURIComponent(code)}`), {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Failed to update parameter: ${await getErrorMessage(response)}`);
  }

  return response.json();
};
